<template>
  <div id="app" :class="{'logged-user': !!$store.getters['loggedUser'], 'help-visible': $store.getters['help'] }">
    <div class="content-bg" :style="{opacity:$store.getters.loading?0:1}">
      <router-view/>
    </div>
    <div id="help" v-if="$store.getters['help']">
      <iframe :src="$store.getters['help']" width="100%" height="100%" noborder />
    </div>
    <div id="nav" class="sidebar" v-if="!!$store.getters['loggedUser']">
      <div class="logo">
        <img :src="$hisport.getLogo()"> 
      </div>
      <div class="account">
        <a href="javascript: void 0" @click="showAccountPanel = !showAccountPanel" xto="/account" >
          <img alt="User" style="background:#FFFFFF;"
              :src="$hisport.absolute(me.logo, {default:'/images/user_default.png', w: 64, h: 64, q: 80, f: 'png'})" v-img-fallback="'/images/user_default.png'"> 
        </a>
        <font-awesome-icon class="account-admin" :icon="['fas','medal']" v-if="$hisport.permissions.isAdmin()"></font-awesome-icon>
        <div class="account-panel-wrapper" v-show="showAccountPanel">
          <account-panel/>
        </div>
      </div>
      <div class="menu">
        <router-link 
            v-for="menu in f_menus" 
            :key="menu.url" 
            :to="menu.url"
            class="route"
            :class="{'route-selected': menu.url.split('/')[1] == $route.path.split('/')[1]}"
            >
            <img :alt="menu.title" :src="menu.icon" />
            <span v-i18n="menu.title">{{menu.title}}</span>
        </router-link>
      </div>
      <div class="btm-menu">
        <font-awesome-icon :icon="['fas','expand']"   class="mobile-only" v-if="!fullscreen" @click="toggleFullscreen"></font-awesome-icon>
        <font-awesome-icon :icon="['fas','compress']" class="mobile-only" v-else @click="toggleFullscreen"></font-awesome-icon>
      </div>
    </div>
    <div class="loading" :class="{active: $store.getters.loading}" :style="{opacity:$store.getters.loading?1:0}">
      <div id="stage">
        <div id="traveler">
          <div id="bouncer">
            <font-awesome-icon :icon="['fas','futbol']"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
#app{display:flex}
.help-visible .content-bg{width:66vw}
#help{height: 100vh; width: 33vw; }
</style>
<script>
import _ from "lodash";
import accountPanel from "./views/account/account"

import firebase             from "firebase/app";
import "firebase/analytics";
import "firebase/messaging";
import Axios                from 'axios';

export default {
  components: {
    accountPanel
  },
  mounted(){
    document.body.addEventListener('mousemove', this.handleInteraction);
    document.body.addEventListener('scroll', this.handleInteraction);
    document.body.addEventListener('keydown', this.handleInteraction);
    document.body.addEventListener('click', this.handleInteraction);
    document.body.addEventListener('mousedown', this.handleInteraction);
    document.body.addEventListener('touchstart', this.handleInteraction);
    
    this.handleInteraction();
    var ua = navigator.userAgent;
    var isMobile = /Android|webOS|iPhone|iPad|iPod/i.test(ua);
    if(isMobile)
      document.body.classList.add("mobile");

  },
  methods:{
    toggleFullscreen: function(){
      var p = (this.fullscreen)?this.exitFullscreen():this.goFullscreen();
      var self = this;
      p.then(function(){
        self.fullscreen = !self.fullscreen
        if(self.fullscreen)
          document.body.classList.add("fullscreen");
        else
          document.body.classList.remove("fullscreen");
      })
      .catch(function(error){
        console.error("Error toggle fullscreen", error)
        alert("ERROR " + error)
      })
    },
    goFullscreen: function(){
      var element = document.body;
      if(!element) return Promise.reject("NO_ELEMENT");
      var self = this;
      var handleFullscreenChange = function(/*event*/){
        // document.fullscreenElement will point to the element that
        // is in fullscreen mode if there is one. If not, the value
        // of the property is null.
        if (document.fullscreenElement) {
          self.$set(self, "fullscreen", true);
        } else {
          console.log('Leaving full-screen mode.');
          self.$set(self, "fullscreen", false);
          self.removeEventListener('fullscreenchange', handleFullscreenChange);
        }
      }
      element.addEventListener('fullscreenchange', handleFullscreenChange)
      if (element.requestFullscreen) {
        return element.requestFullscreen(); //edge do somethig else
      } else if (element.msRequestFullscreen) {
        return element.msRequestFullscreen(); //edge do somethig else
      } else if (element.mozRequestFullScreen) {
        return element.mozRequestFullScreen(); //mozilla do somethig else  
      } else if (element.webkitRequestFullScreen) {
        return element.webkitRequestFullScreen(); //safari do somethig else
      }
      return Promise.reject("NO_METHOD");
    },
    exitFullscreen: function(){
      var element = document
      if(!element) return Promise.reject("NO_ELEMENT");
      if (element.exitFullscreen) {
        return element.exitFullscreen(); //edge do somethig else
      } else if (element.msExitFullscreen) {
        return element.msExitFullscreen(); //edge do somethig else
      } else if (element.mozExitFullscreen) {
        return element.mozExitFullscreen(); //mozilla do somethig else  
      } else if (element.webkitExitFullscreen) {
        return element.webkitExitFullscreen(); //safari do somethig else
      }
      return Promise.reject("NO_METHOD");
    },
    startCount: function(){
        document.body.classList.remove("user-stopped");
    },
    stopCount: _.debounce(function(){
        document.body.classList.add("user-stopped");
    }, 5000, {leading: false, trailing: true}),
    
    handleInteraction(){
      if(document.body.classList.contains("user-stopped"))
          this.startCount();
      this.stopCount();  
    },
    subscribe: async function(id_external) {
      try{
            let _API_           = [
              'https:',
              this.$hisport.options.platform.backend,
              '/push-notifications/subscribe'
            ].join('');

            if (!firebase.apps.length) {
              firebase.initializeApp(this.$hisport.options.platform.firebase.config);
              firebase.analytics();
            }

            var messaging = firebase.messaging();
            messaging.getToken({vapidKey: this.$hisport.options.platform.firebase.vapidKey})
            .then(function(currentToken){
                if(!currentToken)
                    return console.log("TODO SHOWING permission request")
                console.log("CURRENT_TOKEN", currentToken)
                return Axios.post(_API_, {token: currentToken, topic: id_external})
            })
            .then(function(x) { console.info(x) })
            .catch(function(error){ console.error("ERROR RETRIEVING TOKEN", error) })

            messaging.onMessage(function(x) {
                console.info('received foreground', x)

                alert(JSON.stringify(x))
            })
        }catch(e){
            console.warn("Unable to start firebase", e)
        }
    }
  },
  data(){
    var self = this;
    return {
      showAccountPanel: false,
      fullscreen: false,
      menus: [
        { title: "MN_HOME",       url: "/",             icon: require("./assets/menu_icons/home.svg"),        condition: function(){return true;} },
        { title: "MN_EVENTS",     url: "/events",       icon: require("./assets/menu_icons/video.svg"),       condition: function(){return !self.$hisport.options.platform.CONFIGURATION.SHOW_EVENTS_AS_MYCLUBS && self.$hisport.permissions.handleStructures();} },
        { title: "MN_MANAGEMENT", url: "/entities",     icon: require("./assets/menu_icons/teams.svg"),       condition: function(){
                                                                                                                return  self.$hisport.permissions.handleDistributors() || 
                                                                                                                        self.$hisport.permissions.handleStructures() || 
                                                                                                                        self.$hisport.permissions.handleClubs(); } },
        { title: "MN_MYCLUBS",    url: "/events",       icon: require("./assets/menu_icons/video.svg"),       condition: function(){return self.$hisport.options.platform.CONFIGURATION.SHOW_EVENTS_AS_MYCLUBS} },
        { title: "MN_USERS",      url: "/users",        icon: require("./assets/menu_icons/users.svg"),       condition: function(){return self.$hisport.permissions.isAdmin();} },
        { title: "MN_MYGALLERY",  url: "/videos",       icon: require("./assets/menu_icons/structures.svg"),  condition: function(){return self.$hisport.options.platform.CONFIGURATION.SHOW_MYGALLERY;} },
        { title: "MN_CATEGORIES", url: "/categories",   icon: require("./assets/menu_icons/categories.svg"),  condition: function(){return self.$hisport.options.platform.CONFIGURATION.ENABLE_CATEGORIES && self.$hisport.permissions.handleCategories();} },
        { title: "MN_SEASONS",    url: "/seasons",      icon: require("./assets/menu_icons/seasons.svg"),     condition: function(){return self.$hisport.options.platform.CONFIGURATION.ENABLE_SEASONS && self.$hisport.permissions.handleSeasons();} },
        { title: "MN_HIBOX",      url: "/hibox",        icon: require("./assets/menu_icons/box.svg"),         condition: function(){return self.$hisport.permissions.isAdmin();} },
        { title: "MN_HELP",       url: "/help",         icon: require("./assets/menu_icons/faq.svg"),         condition: function(){
                                                                                                                return  self.$hisport.options &&
                                                                                                                        self.$hisport.options.platform &&
                                                                                                                        self.$hisport.options.platform.help &&
                                                                                                                        Array.isArray(self.$hisport.options.platform.help.pages) &&
                                                                                                                        self.$hisport.options.platform.help.pages.length > 0;} }
      ]
    }
  },
  computed: {
    me: function(){
      let self = this;
      let me = self.$store.getters['loggedUser'];
      
    //   ERROR launched every 1 minutes
      if(me && this.$hisport.options.platform.firebase)
        self.subscribe(me.id_external)
      
      return me
    },
    f_menus: function(){
      return this.menus.filter(function(x){return x.condition()});
    }
  },
  watch:{
    $route: function(){ 
      this.showAccountPanel = false;
    }
  } 
}
</script>